import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatTanggal, formatRupiah } from "../../../Utils";

const LapharianRekap = (data, tglmulai, tglakhir) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const title = `Laporan Rekap Jurnal\nTanggal: ${formatTanggal(tglmulai)} s/d ${formatTanggal(tglakhir)}`;
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};

const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);
};
 

  doc.setFontSize(12);
  doc.text(title, pageWidth / 2, 40, { align: "center" });

  const headers = [["Kode Perkiraan", "Nama Perkiraan", "Debet", "Kredit"]];

  let totalDebet = 0;
  let totalKredit = 0;

  const body = data.map(item => {
    const debet = parseFloat(item.debet) || 0;
    const kredit = parseFloat(item.kredit) || 0;

    totalDebet += debet;
    totalKredit += kredit;

    return [
      item.kdperk || "-",
      item.perkiraan || "-",
      formatRupiah(debet),
      formatRupiah(kredit)
    ];
  });

  body.push([
    { content: "Total", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } },
    { content: formatRupiah(totalDebet), styles: { halign: "right", fontStyle: "bold" } },
    { content: formatRupiah(totalKredit), styles: { halign: "right", fontStyle: "bold" } }
  ]);

  const renderTable = (startY) => {
  autoTable(doc, {
    head: headers,
    body: body,
    startY,
    theme: "grid",
    styles: { fontSize: 9, cellPadding: 1 },
    headStyles: {
      fillColor: [27, 188, 155],
      halign: "center",
    },
    margin: { left: 10, right: 10 },
    tableWidth: "auto",
    columnStyles: {
      0: { halign: "center" },
      1: { halign: "left" },
      2: { halign: "right" },
      3: { halign: "right" },
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    drawHeader(logoDataUrl);
    renderTable(52);
  })
  .catch(() => {
    drawHeader();
    renderTable(52);
  });
};

export default LapharianRekap;
